import React from "react";
import CustomLogin from "../components/Login/CustomLogin";

export default function SignIn() {
	return <CustomLogin />;
}
